export const sources = {
  flowingWater: {
    id: 'sources-flowing-water',
    type: 'vector',
    pmtilesFile: 'Stromend_water.pmtiles',
    promoteId: {
      Stromend_water: 'ID_stromend',
    },
  },
  stillWater: {
    id: 'sources-still-water',
    type: 'vector',
    pmtilesFile: 'Stilstaand_water.pmtiles',
    promoteId: {
      Stilstaand_water: 'ID_stilstaand',
    },
  },
  rwzi: {
    id: 'sources-rwzi',
    type: 'vector',
    pmtilesFile: 'RWZI.pmtiles',
    promoteId: {
      RWZI: 'ID_RWZI',
    },
  },
};

const gradientColors = {
  blue: '#4D8FD2',
  purple: '#806D9A',
  red: '#E43A20',
  grey: '#9AA3A6',
};

const sourceProperties = {
  flowingWater: {
    'potential': 'Bronpotentieel_jaar_bronsleutel6',
    'temperature': 'DeltaTavg_bronsleutel6',
    'heat-delivered': 'totale_warmte_geleverd_combosleutel_bs6_vs1',
  },
  stillWater: {
    'potential': 'Bronpotentieel_jaar_bronsleutel6',
    'temperature': 'gemiddelde_delta_bronsleutel6',
    'heat-delivered': 'totale_warmte_geleverd_combosleutel_bs6_vs1',
  },
  rwzi: {
    'potential': 'maximaal_piek_bronpotentieel',
    'heat-delivered': 'totale_warmte_geleverd_combosleutel_bs6_vs1',
  },
};

export function getSourceColorExpression(
  mode,
  sourceType,
  dimmed = false,
  maximumOverride,
) {
  if (sourceType === 'rwzi' && mode === 'temperature') {
    return gradientColors.grey;
  }

  const property = sourceProperties[sourceType][mode];
  const maximumByMode = {
    'potential': 4200,
    'temperature': 2,
    'heat-delivered': 800,
  };
  const defaultMaximum = sourceType === 'flowingWater'
    ? maximumByMode[mode]
    : { 'potential': 900, 'temperature': 2, 'heat-delivered': 200 }[mode];
  const maximum = Number.isFinite(maximumOverride) && maximumOverride > 0
    ? maximumOverride
    : defaultMaximum;
  const value = mode === 'temperature'
    ? ['-', 0, ['coalesce', ['get', property], 0]]
    : ['/', ['coalesce', ['get', property], 0], 1000000];
  const gradient = [
    'interpolate',
    ['linear'],
    ['min', ['max', value, 0], maximum],
    0,
    gradientColors.blue,
    maximum / 2,
    gradientColors.purple,
    maximum,
    gradientColors.red,
  ];

  return [
    'case',
    ['boolean', ['feature-state', 'hover'], false],
    gradient,
    dimmed ? gradientColors.grey : gradient,
  ];
}

export const layers = {
  flowingWater: {
    'id': 'sources-flowing-water',
    'type': 'line',
    'source': sources.flowingWater.id,
    'source-layer': 'Stromend_water',
    'paint': {
      'line-color': getSourceColorExpression('potential', 'flowingWater'),
      'line-width': [
        'case',
        ['boolean', ['feature-state', 'hover'], false],
        4,
        2,
      ],
    },
  },
  flowingWaterHitArea: {
    'id': 'sources-flowing-water-hit-area',
    'type': 'line',
    'source': sources.flowingWater.id,
    'source-layer': 'Stromend_water',
    'layout': {
      'line-cap': 'round',
    },
    'paint': {
      'line-color': '#000',
      'line-opacity': 0,
      'line-width': 14,
    },
  },
  stillWater: {
    'id': 'sources-still-water',
    'type': 'fill',
    'source': sources.stillWater.id,
    'source-layer': 'Stilstaand_water',
    'paint': {
      'fill-color': getSourceColorExpression('potential', 'stillWater'),
      'fill-opacity': [
        'case',
        ['boolean', ['feature-state', 'hover'], false],
        0.8,
        0.6,
      ],
      'fill-outline-color': '#217F9A',
    },
  },
  stillWaterOutline: {
    'id': 'sources-still-water-outline',
    'type': 'line',
    'source': sources.stillWater.id,
    'source-layer': 'Stilstaand_water',
    'paint': {
      'line-color': getSourceColorExpression('potential', 'stillWater'),
      'line-width': [
        'case',
        ['boolean', ['feature-state', 'hover'], false],
        3,
        1.5,
      ],
    },
  },
  rwzi: {
    'id': 'sources-rwzi',
    'type': 'circle',
    'source': sources.rwzi.id,
    'source-layer': 'RWZI',
    'minzoom': 10,
    'paint': {
      'circle-color': getSourceColorExpression('potential', 'rwzi'),
      'circle-radius': [
        'case',
        ['boolean', ['feature-state', 'hover'], false],
        7,
        5,
      ],
      'circle-stroke-color': '#fff',
      'circle-stroke-width': [
        'case',
        ['boolean', ['feature-state', 'hover'], false],
        2,
        1,
      ],
    },
  },
};
